<template>
    <div>
        <button v-if="showInfoModal()" @click="appendDataToModal" data-toggle="modal" type="button"
                style="border-color: white;color: #0a6aa1">
            <i class="fa fa-info"></i>
        </button>

        <div class="d-flex d-inline px-3 justify-content-around" v-if="row.status === walletTransactionStatus.UNKNOWN_YET">
            <div v-if="!loading" class="text-success" style="cursor: pointer; font-size: 14px" @click="make_success()">
                <i class="fas fa-check"></i>
            </div>
            <div v-else class="text-success" style="cursor: pointer; font-size: 12px">
                <span class="spinner-grow text-success"></span>
            </div>

            <div v-if="!loading" class="text-danger" style="cursor: pointer; font-size: 14px" @click="make_failed()">
                <i class="fas fa-times"></i>
            </div>
            <div v-else class="text-danger" style="cursor: pointer; font-size: 12px">
                <span class="spinner-grow text-danger"></span>
            </div>
        </div>
        <div v-if="row.type === walletTransactionType.CHARGE_BY_SETTLEMENT_REVERSAL">
            <span v-text="$t('label.wallet_reversal_hashid')"></span>&nbsp;
            <span>{{ row.rev_id }}</span>
        </div>
        <div
            v-if="(row.type === walletTransactionType.CHARGE_BY_RECEIPT || row.type === walletTransactionType.CHARGE_BY_RECEIPT_FINALLY || row.type === walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER) && row.status === walletTransactionStatus.SUCCESS">
            <router-link v-if="$can('charge-user-wallet-by-receipt','wallet')" :to="{name: 'ayande_wallets_update_receipt', params: {hashid: row.id, slug: 'pf'}}"  >
                <i class="fas fa-pencil-alt"></i>
            </router-link>
        </div>


        <div class="text-info" style="cursor: pointer" @click="getData(row)" v-if="row.type === walletTransactionType.TRANSFER || row.type === walletTransactionType.CHARGE_BY_TRANSFER">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <i v-else class="fas fa-info"></i>
        </div>

        <div  v-if="row.type === walletTransactionType.TRANSFER || row.type === walletTransactionType.CHARGE_BY_TRANSFER" class="modal fade" :id="`show_details_${row.id}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
              aria-hidden="true">

            <div
                class="modal-dialog modal-lg modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="text-center">توضیحات</div>
                        <form class="mt-5 mx-5 mb-2">
                            <div class="row my-2 bg-white p-1">

                                <div class="col-12 col-md-6 my-2">
                                    <div class="text-left">{{ $t('label.transaction_type') }}</div>
                                    <input class="form-control"
                                           :value="walletTransactionTypeStr.get(row.type)"
                                           disabled
                                    >
                                </div>

                                <div class="col-12 col-md-6 my-2">
                                    <div class="text-left">{{ $t('label.total_amount') }}</div>
                                    <input class="form-control"
                                           :value="row.amount"
                                           disabled
                                    >
                                </div>
                                <div class="col-12 col-md-6 my-2">
                                    <div class="text-left">{{ $t('label.status') }}</div>
                                    <input
                                        :class="`form-control text-white bg-${walletTransactionStatusVariant(row.status)}`"
                                        :value="walletTransactionStatusStr.get(row.status) + (false ? ' (' + $t('label.reversal') + ')' : '')"
                                        disabled
                                    >
                                </div>

                                <div class="col-12 col-md-6 my-2">
                                    <div class="text-left">{{ $t('label.payment_date') }}</div>
                                    <input class="form-control"
                                           style="direction: ltr;"
                                           :value="row.created_at"
                                           disabled
                                    >
                                </div>

                                <div class="col-12 col-md-12 my-2">
                                    <div class="text-left">{{ $t('label.description') }}</div>

                                    <textarea class="form-control" :value="fetchTransfer.transfer_description" disabled rows="4"></textarea>
                                </div>

                            </div>

                            <table
                                class="table table-bordered bg-white"
                            >
                                <tr>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_to'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_from'
                                                    )
                                                "
                                    ></td>

                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_from'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_to'
                                                    )
                                                "
                                    ></td>

                                </tr>
                                <tr>
                                    <td v-if="fetchTransfer.from">{{ fetchTransfer.from.user }}</td>
                                    <td v-if="fetchTransfer.to">{{ fetchTransfer.to.user }}</td>
                                    <td v-if="fetchTransfer.from">{{ fetchTransfer.from.wallet_id }}</td>
                                    <td v-if="fetchTransfer.to">{{ fetchTransfer.to.wallet_id }}</td>
                                </tr>
                            </table>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tr_title" style="text-align: center">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="request_details" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead id="table-header">
                            <tr>
                            </tr>
                            </thead>
                            <tbody id="request_details_body">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    walletTransactionStatus,
    walletTransactionStatusStr,
    walletTransactionStatusVariant
} from "@/constants/walletTransactionStatus";
import {walletTransactionType, walletTransactionTypeStr} from "@/constants/walletTransactionType";
import {authService, walletService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import state from '@/store';
import $ from "jquery";

export default Vue.extend({
    computed: {
        walletTransactionTypeStr() {
            return walletTransactionTypeStr
        },
        walletTransactionStatusStr() {
            return walletTransactionStatusStr
        },
        state() {
            return state;
        },
        slug() {
            return this.$route.params.slug || this.$route.query.slug;
        },
    },
    data() {
        return {
            walletTransactionStatus,
            walletTransactionType,
            fetchTransfer: {},
            loading: false,
        };
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    methods: {
        walletTransactionStatusVariant,
        getData(row) {
            this.fetchTransfer = {}
            this.loading = true;

          walletService.getAdminSettlementDetailAyande(row.id).then(res => {
                this.fetchTransfer = res.data.data;
                $(`#show_details_${row.id}`).modal("show")
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);
            }).finally(() => {
                this.loading = false;
            });

        },
        make_success() {
            let phone = this.state.getters["auth/user"].phone;

            let verify = {
                phone,
            };
            this.loading = true;
                authService.sendVerifyWallet(verify).then(res => {
                    let code = prompt(i18n.t('message.are_you_sure_to_change_unknown_yet_status_to_success'), '');

                    if (code === null || code === undefined || code === '') {
                        return;
                    }
                    let params = {
                        wallet_prefix: 'A',
                        phone: phone,
                        code: code,
                        status: walletTransactionStatus.SUCCESS,
                    };
                    this.loading = true;

                    walletService.changeUnknownYetStatus(params, this.row.id).then(res => {
                        window.location.reload();
                    }).catch(({response}) => {
                        this.loading = false;
                        this.toastr.error(response.data.message);
                    }).finally(() => {
                        this.loading = false;
                    });

                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    this.loading = false;
                });

        },

            make_failed() {
                let phone = this.state.getters["auth/user"].phone;

                let verify = {
                    phone,
                };
                this.loading = true;
                    authService.sendVerifyWallet(verify).then(res => {
                        let code = prompt(i18n.t('message.are_you_sure_to_change_unknown_yet_status_to_failed'), '');

                        if (code === null || code === undefined || code === '') {
                            return;
                        }

                        let params = {
                            wallet_prefix: 'A',
                            phone: phone,
                            code: code,
                            status: walletTransactionStatus.FAILED,
                        };
                        this.loading = true;

                        walletService.changeUnknownYetStatus(params, this.row.id).then(res => {
                            window.location.reload();
                        }).catch(({ response }) => {
                            this.loading = false;
                            this.toastr.error(response.data.message);
                        });

                }).catch(({ response }) => {
                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    this.loading = false;
                });

        },
        showInfoModal() {
            return this.row.detected_by || this.row.detected_by === 0 || this.row.reversed_by || this.row.reversed_by === 0;
        },
        appendDataToModal() {
            $("#description_modal").modal('show')
            let tr_body = $('#request_details_body').empty()
            let tr_header = $('#table-header').empty()
            let tr_title = $('#tr_title').empty()
            let ps_elements = '<h4 class="modal-title float-right p-0 m-0">' + this.row.id + '</h4>'
            tr_title.append(ps_elements)

            if (this.row.detected_by || this.row.detected_by === 0) {
                if (this.row.detected_by === 0) {
                    tr_body.append(
                        ' <tr><th>' + i18n.t('label.detected_type') + '</th><th>' + i18n.t('label.reversed_automatically') + '</th></tr>');
                } else {
                    let detected_link = '/users/' + this.row.detected_by.id + '/details';
                    tr_body.append(`
                      <tr><th>${i18n.t('label.detected_type')}</th><th><a href="${detected_link}">${this.row.detected_by.name}</a></th></tr>`);
                }
            }
            if (this.row.reversed_by || this.row.reversed_by === 0) {
                if (this.row.reversed_by === 0) {
                    tr_body.append(
                        ' <tr><th>' + i18n.t('label.reversed_type') + '</th><th>' + i18n.t('label.reversed_automatically') + '</th></tr>');
                } else {
                    let reversed_link = '/users/' + this.row.reversed_by.id + '/details';
                    tr_body.append(`
                      <tr><th>${i18n.t('label.reversed_type')}</th><th><a href="${reversed_link}">${this.row.reversed_by.name}</a></th></tr>`);
                }
            }
        }

    },
})
</script>
